import { Injectable } from '@angular/core';
import {BaseRestService} from '../../shared/services/base-rest.service';
import {HttpClient} from '@angular/common/http';
import {AppSettingsService} from '../../shared/services/app-settings.service';
import {Observable} from 'rxjs';
import {SendBackResult} from '../../shared/models/send-back-result';
import {ArrayResponse, serializeQueryString} from '..';
import {CompaniesList} from '../../company/models/companies-list';
import {ContractLink, ContractLinkSummaries} from '../models/contract-link';

@Injectable({
  providedIn: 'root'
})
export class ContractLinkServiceService  extends BaseRestService  {

  constructor(http: HttpClient, appSettingsService: AppSettingsService) {
    super(http, appSettingsService);
  }
  protected get className(): string { return 'ContractLinkServiceService'; }
  protected get isAnonymous(): boolean { return false; }

  // tslint:disable-next-line:no-any
  loadCompanies(filter: any): Observable<SendBackResult<ArrayResponse<CompaniesList>>> {
    return this.get<ArrayResponse<CompaniesList>>(`/Companies${serializeQueryString(filter)}`);
  }
  loadSubscriptions(filter: Object): Observable<SendBackResult<ArrayResponse<ContractLinkSummaries>>> {
    return this.get<ArrayResponse<ContractLinkSummaries>>(`/Subscription/Summaries${serializeQueryString(filter)}`);
  }

  loadContract(filter: Object): Observable<SendBackResult<ArrayResponse<ContractLinkSummaries>>> {
    return this.get<ArrayResponse<ContractLinkSummaries>>(`/Contract/Summaries${serializeQueryString(filter)}`);
  }

  update(link: ContractLink): Observable<SendBackResult<boolean>> {
    if (!link.isActualCompanyLink) {
      return this.put<boolean>(`/Company/${link.companies.uuid}/Contract/${link.contracts.uuid}/ContractTimeLinks`, link);
    } else {
      return this.put<boolean>(`/Contract/${link.contracts.uuid}/ContractTimeLinks`, link);
    }
  }
}
